import { feathers } from '@/feathers-client';

/**
 * Custom fields vuex store
 */
export default {
  namespaced: true,
  state: {
    customFieldTypes: [],
    customField: null,
    error: null,
    hasError: false,
    loading: false
  },
  mutations: {
    setCustomFieldTypes(state, customFieldTypes) {
      state.customFieldTypes = customFieldTypes.map(type => type.name);
    },
    setCustomField(state, customField) {
      state.customField = customField;
    },
    setError(state, error) {
      state.error = error;
      state.hasError = !!error;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    clearMessages(state) {
      state.loading = false;
      state.error = null;
      state.hasError = false;
      state.customField = null;
    },
  },
  actions: {
    async findCustomFieldTypes({ commit }) {
      const customFieldTypes = await feathers.service('custom-field-types').find();
      commit('setCustomFieldTypes', customFieldTypes.data);
    },
    async createCustomField({ commit }, customField) {
      commit('setLoading', true);
      try {
        const newCustomField = await feathers.service('custom-fields').create(customField);
        commit('setCustomField', newCustomField);
        return newCustomField.id;
      } catch (error) {
        commit('setError', error);
      }
      commit('setLoading', false);
    },
  },
};
